export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value))
}

/**
 * 디자인 원본의 구간 매핑. p가 a 이하면 0, b 이상이면 1, 사이는 선형이다.
 * 히어로/엔딩 텍스트 전환 계수를 이 함수로 그대로 재현한다.
 */
export function ramp(p: number, a: number, b: number): number {
  if (b === a) return p >= b ? 1 : 0
  return clamp((p - a) / (b - a), 0, 1)
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
